package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_register_configuration.tabs.hardware.component.hardware_kitchen_location

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import org.hs_soft.runmynesto.domain.config.*
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.KitchenLocationPrintersEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.kotlin_api.*
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.Constants.ipAddressRegex
import org.hs_soft.runmynesto.domain.util.Constants.sunmiSerialLength
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.*
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun HardwareKitchenLocations(
    windowSizeMode: WindowSizeModeEnum,
    cashRegisterConfig: CashRegisterConfig?,
    updateCashRegisterConfig: (List<Pair<String, dynamic>>) -> Unit
) {

    val separateKitchenReports = remember { mutableStateOf(cashRegisterConfig?.separateKitchenReports ?: false) }
    val showPriceOnKitchenReport = remember { mutableStateOf(cashRegisterConfig?.showPriceOnKitchenReport ?: false) }
    val printNextCoursePositions = remember { mutableStateOf(cashRegisterConfig?.printNextCoursePositions ?: false) }
    val availableRooms = remember { mutableStateOf(cashRegisterConfig?.restaurantAvailableRooms ?: emptyList()) }

    LaunchedEffect(cashRegisterConfig) {
        separateKitchenReports.value = cashRegisterConfig?.separateKitchenReports ?: false
        showPriceOnKitchenReport.value = cashRegisterConfig?.showPriceOnKitchenReport ?: false
        printNextCoursePositions.value = cashRegisterConfig?.printNextCoursePositions ?: false
        availableRooms.value = cashRegisterConfig?.restaurantAvailableRooms ?: emptyList()
    }

//    MediumContentTitle(
//        title = Strings.current().kitchenSettings,
//        marginBottom = 0.px,
//        marginTop = Dimen.mediumPadding,
//    )

    Row(
        modifier = Modifier
            .margin(topBottom = Dimen.smallPadding)
            .fillMaxWidth()
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
            .borderRadius(Dimen.lowBorderRadius)
            .padding(Dimen.normalPadding),
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            CheckboxComponent(
                checkStatus = separateKitchenReports.value,
                title = Strings.current().separateKitchenReport,
                onChecked = {
                    separateKitchenReports.value = true

                    updateCashRegisterConfig(
                        buildList { add(ApiUtils.Field.separateKitchenReports to true) }
                    )
                },
                onUnChecked = {
                    separateKitchenReports.value = false

                    updateCashRegisterConfig(
                        buildList { add(ApiUtils.Field.separateKitchenReports to false) }
                    )
                }
            )

            CheckboxComponent(
                checkStatus = showPriceOnKitchenReport.value,
                title = Strings.current().priceShowOnKitchenReceipt,
                onChecked = {
                    showPriceOnKitchenReport.value = true

                    updateCashRegisterConfig(
                        buildList { add(ApiUtils.Field.showPriceOnKitchenReport to true) }
                    )
                },
                onUnChecked = {
                    showPriceOnKitchenReport.value = false

                    updateCashRegisterConfig(
                        buildList { add(ApiUtils.Field.showPriceOnKitchenReport to false) }
                    )
                }
            )

            CheckboxComponent(
                checkStatus = printNextCoursePositions.value,
                title = Strings.current().printDishesOfTheNextCourse,
                onChecked = {
                    printNextCoursePositions.value = true

                    updateCashRegisterConfig(
                        buildList { add(ApiUtils.Field.printNextCoursePositions to true) }
                    )
                },
                onUnChecked = {
                    printNextCoursePositions.value = false

                    updateCashRegisterConfig(
                        buildList { add(ApiUtils.Field.printNextCoursePositions to false) }
                    )
                }
            )


            /* Not in use
            Row(
                modifier = Modifier.margin(top = Dimen.normalPadding),
                verticalAlignment = Alignment.CenterVertically
            )
            {

                CustomEditText(
                    modifier = Modifier,
                    label = Strings.current().topEdgeCm,
                    value = (parameters?.printer?.topMargin ?: 0).toString(),
                    marginTop = Dimen.normalPadding,
                    width = Dimen.normalEditTextWidth,
                    isOutlinedEditText = true,
                    isRequired = false,
                    inputType = InputType.Number,
                    defaultBorderColor = Theme.ActionDisabledBackground.rgb,
                    hint = "",
                    onFocusIn = {},
                    onFocusOut = {
                        updateCashRegisterConfig(
                            ApiUtils.Field.printer,
                            getPrintJson(
                                title = ApiUtils.Field.topMargin,
                                value = it.toInt()
                            ),
                            false
                        )
                    },
                    onInputChange = { it, validation ->

                    },
                )
                CheckboxComponent(
                    modifier = Modifier
                        .margin(left = Dimen.mediumPadding),
                    title = Strings.current().separateCakeToppings,
                    checkStatus = parameters?.printer?.separateKitchenBill ?: false,
                    onUnChecked = {
                        updateCashRegisterConfig(
                            ApiUtils.Field.printer,
                            getPrintJson(
                                title = ApiUtils.Field.separateKitchenBill,
                                value = false
                            ),
                            false
                        )
                    },
                    onChecked = {
                        updateCashRegisterConfig(
                            ApiUtils.Field.printer,
                            getPrintJson(
                                title = ApiUtils.Field.separateKitchenBill,
                                value = true
                            ),
                            false
                        )
                    }
                )
            }*/

            MediumContentTitle(
                title = Strings.current().kitchenLocations,
                marginBottom = 0.px,
                marginTop = Dimen.mediumPadding,
            )

            Column(
                modifier = VerticalScrollBehavior.toModifier()
                    .weight(1f)
//               .fillMaxHeight()
                    .fillMaxWidth()
//               .styleModifier {
//                   flexGrow(1)
//                   overflowY(Overflow.Auto)
//                   display(DisplayStyle.Flex)
//               }
            ) {

                cashRegisterConfig?.kitchenStations?.forEach { station ->
                    HardwareKitchenStationItem(
                        windowSizeMode = windowSizeMode,
                        stationConfig = station,
                        availableRooms = cashRegisterConfig.restaurantAvailableRooms?: listOf(),
                        availablePrinters = cashRegisterConfig.availablePrinters?: listOf(),
                        availableKds = cashRegisterConfig.availableKds?: listOf(),
                        updateData = { updateList: List<Pair<String, dynamic>> ->
                            updateCashRegisterConfig(updateList)
                        }
                    )
                }
            }
        }
    }
}

fun getStationConfigToStore(type: KitchenLocationPrintersEnum?, connectionTarget: String, kdsSN: String): Pair<String, String>? {
    return when(type) {
        null -> "" to ""

        KitchenLocationPrintersEnum.EPSON_M30 -> {
            if (Regex(ipAddressRegex).matches(connectionTarget)) {
                connectionTarget to if (kdsSN.isBlank()) "local_printer" else "local_printer;${kdsSN}"
            } else null
        }

        KitchenLocationPrintersEnum.SUNMI_CLOUD_BY_IP -> {
            if (Regex(ipAddressRegex).matches(connectionTarget)) {
                connectionTarget to if (kdsSN.isBlank()) "sunmi" else "sunmi;${kdsSN}"
            } else null
        }

        KitchenLocationPrintersEnum.SUNMI_CLOUD_BY_SERVER -> {
            if (connectionTarget.length == sunmiSerialLength) {
                connectionTarget to if (kdsSN.isBlank()) "sunmi_cloud" else "sunmi_cloud;${kdsSN}"
            } else null
        }

        KitchenLocationPrintersEnum.KITCHEN_DISPLAY_KDS -> {
            if (kdsSN.isNotBlank()) {
                "" to kdsSN
            } else null
        }
    }
}

@Composable
fun HardwareKitchenStationItem(
    windowSizeMode: WindowSizeModeEnum,
    stationConfig: KitchenStation,
    availableRooms: List<RestaurantRoom>,
    availablePrinters: List<SunmiDeviceDetails>,
    availableKds: List<SunmiDeviceDetails>,
    updateData: (List<Pair<String, dynamic>>) -> Unit
) {
    Row(
        modifier = Modifier
            .margin(topBottom = Dimen.smallPadding)
            .fillMaxWidth()
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
            .borderRadius(Dimen.lowBorderRadius)
            .padding(Dimen.normalPadding),
    ) {
        val isActive = remember { mutableStateOf(stationConfig.isActive) }
        val waiterCopy = remember { mutableStateOf(stationConfig.waiterCopy) }
        val tableShiftReceipt = remember { mutableStateOf(stationConfig.tableShiftReceipt) }
        val isAnnounce = remember { mutableStateOf(stationConfig.isAnnounce) }
        val stationType = remember { mutableStateOf(stationConfig.getType()) }
        val connectionTarget = remember { mutableStateOf(stationConfig.connectionTarget) }
        val roomsList = remember { mutableStateOf(stationConfig.roomIds) }
        val kdsSN = remember { mutableStateOf(stationConfig.kdsSN) }

        LaunchedEffect(stationConfig) {
            isActive.value = stationConfig.isActive
            waiterCopy.value = stationConfig.waiterCopy
            tableShiftReceipt.value = stationConfig.tableShiftReceipt
            isAnnounce.value = stationConfig.isAnnounce
            stationType.value = stationConfig.getType()
            roomsList.value = stationConfig.roomIds
            kdsSN.value = stationConfig.kdsSN
            connectionTarget.value = stationConfig.connectionTarget
        }

        if (windowSizeMode == WindowSizeModeEnum.Desktop) {
            Column (
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier.fillMaxWidth()
            ) {
                //  STATION NAME
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    SpanText(
                        text = stationConfig.name.orEmpty(),
                        modifier = Modifier
                            .width(
                                if (windowSizeMode == WindowSizeModeEnum.Desktop)
                                    Dimen.printLocationNameWidth
                                else (Dimen.printLocationNameWidth.value.toInt() * 0.75).px
                            )
                            .overflowText()
                            .fontFamily(FontFamily.Jakarta)
                            .fontSize(
                                if (windowSizeMode == WindowSizeModeEnum.Desktop)
                                    FontSizes.mediumFontSize
                                else FontSizes.semiMediumFontSize
                            )
                            .color(Theme.TextPrimary.rgb)
                            .fontWeight(FontWeight.Bold)
                            .margin(bottom = Dimen.normalPadding)
                    )
                }
                // STATION NAME END

                // STATION SETTINGS
                Row(
                    verticalAlignment = Alignment.Top,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    // LEFT SIDE. CHECKBOXES
                    Column(modifier = Modifier.margin(right = Dimen.mediumPadding)) {
                        CheckboxComponent(
                            title = Strings.current().activate,
                            checkStatus = isActive.value,
                            onUnChecked = {
                                isActive.value = false

                                updateData(
                                    buildList { add(stationConfig.isActiveField() to false) }
                                )
                            },
                            onChecked = {
                                isActive.value = true

                                updateData(
                                    buildList { add(stationConfig.isActiveField() to true) }
                                )
                            }
                        )

                        CheckboxComponent(
                            enabled = isActive.value,
                            title = Strings.current().copyForWaiter,
                            checkStatus = waiterCopy.value,
                            onUnChecked = {
                                waiterCopy.value = false

                                updateData(
                                    buildList { add(stationConfig.waiterCopyField() to false) }
                                )
                            },
                            onChecked = {
                                waiterCopy.value = true

                                updateData(
                                    buildList { add(stationConfig.waiterCopyField() to true) }
                                )
                            }
                        )

                        // Table shift checkbox
                        CheckboxComponent(
                            enabled = isActive.value,
                            title = Strings.current().tableShift,
                            checkStatus = tableShiftReceipt.value,
                            onUnChecked = {
                                tableShiftReceipt.value = false

                                updateData(
                                    buildList { add(stationConfig.tableShiftReceiptField() to false) }
                                )
                            },
                            onChecked = {
                                tableShiftReceipt.value = true

                                updateData(
                                    buildList { add(stationConfig.tableShiftReceiptField() to true) }
                                )
                            }
                        )

                        // Announce checkbox
                        CheckboxComponent(
                            enabled = isActive.value,
                            title = Strings.current().kitchenStationAnnounce,
                            checkStatus = isAnnounce.value,
                            onUnChecked = {
                                isAnnounce.value = false

                                updateData(
                                    buildList { add(stationConfig.announceField() to false) }
                                )
                            },
                            onChecked = {
                                isAnnounce.value = true

                                updateData(
                                    buildList { add(stationConfig.announceField() to true) }
                                )
                            }
                        )
                    }
                    // LEFT SIDE. CHECKBOXES END

                    // RIGHT SIDE. SELECTIONS AND TEXTS
                    Column(modifier = Modifier.margin(right = Dimen.normalPadding, bottom = Dimen.normalPadding)) {
                        Row(
                            verticalAlignment = Alignment.Top,
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            DropDownItem(
                                modifier = Modifier.margin(bottom = Dimen.normalPadding, right = Dimen.normalPadding),
                                itemWidth = when(windowSizeMode) {
                                    WindowSizeModeEnum.Desktop -> Dimen.mediumEditTextWidth
                                    WindowSizeModeEnum.TABLET -> Dimen.semiMediumEditTextWidth
                                    WindowSizeModeEnum.PHONE -> Dimen.highNormalEditTextWidth
                                },
                                disable = !isActive.value,
                                options = KitchenLocationPrintersEnum.entries,
                                label = Strings.current().printerType,
                                selectedItem = stationType.value,
                                displayText = { item ->
                                    if (item is KitchenLocationPrintersEnum) item.title else ""
                                },
                                onOptionClick = {
                                    if (it is KitchenLocationPrintersEnum) {
                                        stationType.value = it

                                        getStationConfigToStore(
                                            type = stationType.value,
                                            connectionTarget = connectionTarget.value,
                                            kdsSN = kdsSN.value
                                        )?.let { toStore ->
                                            updateData(
                                                buildList {
                                                    add(stationConfig.ipField() to toStore.first)
                                                    add(stationConfig.idField() to toStore.second)
                                                }
                                            )
                                        }
                                    }
                                },
                                clearAvailable = true,
                                onClearClick = {
                                    isActive.value = false
                                    stationType.value = null
                                    connectionTarget.value = ""
                                    kdsSN.value = ""
                                    roomsList.value = emptyList()

                                    updateData(
                                        buildList {
                                            add(stationConfig.isActiveField() to false)
                                            add(stationConfig.ipField() to "")
                                            add(stationConfig.idField() to "")
                                            add(stationConfig.roomsField() to "")
                                        }
                                    )
                                }
                            )

                            if (stationType.value in listOf(KitchenLocationPrintersEnum.EPSON_M30, KitchenLocationPrintersEnum.SUNMI_CLOUD_BY_IP)) {
                                CustomEditText(
                                    modifier = Modifier,
                                    marginBottom = Dimen.normalPadding,
                                    isEnabled = isActive.value && (stationType.value != null),
                                    label = Strings.current().ipAddress,
                                    width = Dimen.mediumEditTextWidth,
                                    inputType = InputType.Text,
                                    value = connectionTarget.value,
                                    isRequired = true,
                                    hint = "",
                                    onFocusIn = { },
                                    onFocusOut = {
                                        getStationConfigToStore(
                                            type = stationType.value,
                                            connectionTarget = connectionTarget.value,
                                            kdsSN = kdsSN.value
                                        )?.let { toStore ->
                                            updateData(
                                                buildList {
                                                    add(stationConfig.ipField() to toStore.first)
                                                    add(stationConfig.idField() to toStore.second)
                                                }
                                            )
                                        }
                                    },
                                    onInputChange = { it, validation ->
                                        connectionTarget.value = it
                                        validation.value = Regex(ipAddressRegex).matches(it)
                                    }
                                )
                            } else if (stationType.value == KitchenLocationPrintersEnum.SUNMI_CLOUD_BY_SERVER) {
                                DropDownItem(
                                    modifier = Modifier.margin(bottom = Dimen.normalPadding, right = Dimen.normalPadding),
                                    itemWidth = when(windowSizeMode) {
                                        WindowSizeModeEnum.Desktop -> Dimen.mediumEditTextWidth
                                        WindowSizeModeEnum.TABLET -> Dimen.semiMediumEditTextWidth
                                        WindowSizeModeEnum.PHONE -> Dimen.highNormalEditTextWidth
                                    },
                                    disable = !isActive.value || (stationType.value == null),
                                    options = availablePrinters,
                                    label = Strings.current().printer,
                                    selectedItem = availablePrinters.find { it.sn == connectionTarget.value },
                                    displayText = { item ->
                                        if (item is SunmiDeviceDetails) item.name.ifEmpty { item.sn } else ""
                                    },
                                    onOptionClick = {
                                        connectionTarget.value = (it as SunmiDeviceDetails).sn

                                        getStationConfigToStore(
                                            type = stationType.value,
                                            connectionTarget = connectionTarget.value,
                                            kdsSN = kdsSN.value
                                        )?.let { toStore ->
                                            updateData(
                                                buildList {
                                                    add(stationConfig.ipField() to toStore.first)
                                                    add(stationConfig.idField() to toStore.second)
                                                }
                                            )
                                        }
                                    }
                                )
                            }
                        }

                        Row(
                            verticalAlignment = Alignment.Top,
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            DropDownItem(
                                modifier = Modifier.margin(bottom = Dimen.normalPadding, right = Dimen.normalPadding),
                                itemWidth = when(windowSizeMode) {
                                    WindowSizeModeEnum.Desktop -> Dimen.mediumEditTextWidth
                                    WindowSizeModeEnum.TABLET -> Dimen.semiMediumEditTextWidth
                                    WindowSizeModeEnum.PHONE -> Dimen.highNormalEditTextWidth
                                },
                                disable = !isActive.value || (stationType.value == null),
                                options = availableKds,
                                label = Strings.current().snOfKds,
                                selectedItem = availableKds.find { it.sn == kdsSN.value },
                                displayText = { item ->
                                    if (item is SunmiDeviceDetails) item.name.ifEmpty { item.sn } else ""
                                },
                                onOptionClick = {
                                    kdsSN.value = (it as SunmiDeviceDetails).sn

                                    getStationConfigToStore(
                                        type = stationType.value,
                                        connectionTarget = connectionTarget.value,
                                        kdsSN = kdsSN.value
                                    )?.let { toStore ->
                                        updateData(
                                            buildList {
                                                add(stationConfig.ipField() to toStore.first)
                                                add(stationConfig.idField() to toStore.second)
                                            }
                                        )
                                    }
                                },
                                clearAvailable = true,
                                onClearClick = {
                                    kdsSN.value = ""

                                    getStationConfigToStore(
                                        type = stationType.value,
                                        connectionTarget = connectionTarget.value,
                                        kdsSN = kdsSN.value
                                    )?.let { toStore ->
                                        updateData(
                                            buildList {
                                                add(stationConfig.ipField() to toStore.first)
                                                add(stationConfig.idField() to toStore.second)
                                            }
                                        )
                                    }
                                }
                            )

                            DropDownMultiSelect(
                                modifier = Modifier.margin(bottom = Dimen.normalPadding), // Weird, but to have correct space here we need largePadding
                                disable = !isActive.value || (stationType.value == null),
                                options = availableRooms.map { Pair(it.id, it.caption) },
                                selectedIds = roomsList.value,
                                label = Strings.current().rooms,
                                onSelectionChange = { newSelection ->
                                    roomsList.value = newSelection

                                    updateData(
                                        buildList {
                                            add(stationConfig.roomsField() to newSelection.joinToString(separator = ";"))
                                        }
                                    )
                                }
                            )
                        }

                    }
                    // RIGHT SIDE. SELECTIONS AND TEXTS END
                }
                // STATION SETTINGS END
            }
        }
    }
}


fun getPrintJson(
    title:String,
    value:dynamic,
): JsonObject {
    val printerJson = buildJsonObject {
        when(value){
            is Boolean -> put(title, value as Boolean)
            is String -> put(title, value as String)
            is Int -> put(title, value as Int)
        }
    }
    return printerJson
}